import { isArrayLikeObject, isObjectLike, map, isEmpty, includes, find, filter, concat } from 'lodash';

import { resetResolutionOptionsFromResolutionData } from 'commons-vehicle/ModelYear/services/OptionsSelectionResolutionService/OptionsSelectionResolutionService.js';

import OptionsSelectionResolutionsModel from 'commons-vehicle/ModelYear/models/OptionsSelectionResolutionsModel.js';
/* eslint no-bitwise: 0 */

export function resetResolutionOptionsFromResolutionsData(resolutions, configuration, triggerSelectionCode) {
    const optionsSelectionResolutions = new OptionsSelectionResolutionsModel();
    if (
        isEmpty(resolutions) ||
        !isArrayLikeObject(resolutions) ||
        !isObjectLike(configuration) ||
        isEmpty(configuration.selectionCode)
    ) {
        return optionsSelectionResolutions;
    }
    const configurationOptionsSelectionCodes = configuration.getConfigurationOptionsSelectionCodes();
    const originalOptionsSelectionCodes = configuration.getOptionsSelectionCodes();

    const convertedResolutions = map(resolutions, (resolution) => {
        return resetResolutionOptionsFromResolutionData(
            resolution,
            configurationOptionsSelectionCodes,
            originalOptionsSelectionCodes,
            triggerSelectionCode
        );
    });

    // Failed resolution from bad data
    const validResolutions = find(convertedResolutions, (convertedResolution) => !convertedResolution.isCancel);
    if (!validResolutions) {
        const cancelResolution = convertedResolutions[0];
        const invalidResolution = cancelResolution.set('isCancel', false);

        return optionsSelectionResolutions
            .set('triggeredFromOptionAdd', includes(originalOptionsSelectionCodes, triggerSelectionCode))
            .set('resolutionTriggerOptionSelectionCode', triggerSelectionCode)
            .set('resolutions', [cancelResolution, invalidResolution]);
    }

    const nonColourResolutions = filter(convertedResolutions, (convertedResolution) => {
        return !convertedResolution.isExteriorColour && !convertedResolution.isInteriorColour;
    });

    let exteriorColourResolutions = [];
    const exteriorColourResolution = find(convertedResolutions, (convertedResolution) => {
        return convertedResolution.isExteriorColour;
    });
    if (exteriorColourResolution) {
        exteriorColourResolutions = isEmpty(exteriorColourResolution.availableExteriorColours)
            ? [exteriorColourResolution]
            : map(exteriorColourResolution.availableExteriorColours, (availableExteriorColour) => {
                  return exteriorColourResolution
                      .set('id', `A${availableExteriorColour.selectionCode}-${exteriorColourResolution.id}`)
                      .set('addedOptions', concat(exteriorColourResolution.addedOptions, availableExteriorColour))
                      .set(
                          'resolutionActionOptions',
                          concat(
                              exteriorColourResolution.resolutionActionOptions,
                              availableExteriorColour.set('selected', true)
                          )
                      );
              });
    }

    let interiorColourResolutions = [];
    const interiorColourResolution = find(convertedResolutions, (convertedResolution) => {
        return convertedResolution.isInteriorColour;
    });
    if (interiorColourResolution) {
        interiorColourResolutions = isEmpty(interiorColourResolution.availableInteriorColours)
            ? [interiorColourResolution]
            : map(interiorColourResolution.availableInteriorColours, (availableInteriorColour) => {
                  return interiorColourResolution
                      .set('id', `A${availableInteriorColour.selectionCode}-${interiorColourResolution.id}`)
                      .set('addedOptions', concat(interiorColourResolution.addedOptions, availableInteriorColour))
                      .set(
                          'resolutionActionOptions',
                          concat(
                              interiorColourResolution.resolutionActionOptions,
                              availableInteriorColour.set('selected', true)
                          )
                      );
              });
    }

    return optionsSelectionResolutions
        .set('triggeredFromOptionAdd', includes(originalOptionsSelectionCodes, triggerSelectionCode))
        .set('resolutionTriggerOptionSelectionCode', triggerSelectionCode)
        .set('resolutions', concat(nonColourResolutions, exteriorColourResolutions, interiorColourResolutions));
}

export default {
    resetResolutionOptionsFromResolutionsData,
};



// WEBPACK FOOTER //
// ../widget-commons-vehicle/src/ModelYear/services/OptionsSelectionResolutionsService/OptionsSelectionResolutionsService.js